(function () {
    /** CONSTANTS */
    const SYNER_URL = "https://synerserver.herokuapp.com";
    const IS_TEST = false;

    const loadScript = function (url, callback) {
        const script = document.createElement("script");
        script.type = "text/javascript";

        // If the browser is Internet Explorer.
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
            // For any other browser.
        } else {
            script.onload = function () {
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    let tries = 0;

    function buildField(customLocation, $) {
        const field_code = `
            <p class="cart-attribute__field">
                <div class="help-tip">
                    <p style="display: none" >Want to receive a discount code on your next order by promoting our brand? <br/>
                        <br/>
                        Enter your Instagram username and we'll send you an email with instructions on how to share your received items in exchange for a discount.<br/>  
                        <span style="font-size: 8px">
                            Powered by <a href="https://www.syner.co/promotioninstructions" style="color: white"><u>Syner.</u></a>
                        </span>
                    </p>
                </div>
                 <label id="instagram-name-label" for="instagram-name">Promote on instagram for discount</label>
                <div class="synerinstafield">
				<input id="instagram-name" class="input-group__field newsletter__input" type="text" name="attributes[Instagram name]" value="" placeholder="@instagram">
            </div>
		</p>
        `;
        let location = "syner_insta_field_holder";
        if (customLocation) {
            console.log("Using custom syner location");
            location = customLocation;
        }

        const elements = document.getElementsByClassName(location);

        if (elements.length > 0) {
            const first = elements[0];
            first.innerHTML = field_code;
            first.addEventListener('change', (event) => {
                $.post('/cart/update.js', {
                    attributes: {
                        instagramName: event.target.value
                    }
                });
            });
        } else {
            console.log("no elements found, looking for: ", location);
            if (tries < 5) {
                setTimeout(() => {
                    tries++;
                    buildField(customLocation);
                }, 500);
            }
        }
    }

    const myAppJavaScript = function ($) {
        if (window.location.href.indexOf("cart") > -1 || IS_TEST) {
            let shop = "test-voorbeeld-winkel.myshopify.com";
            if (typeof Shopify !== "undefined") {
                shop = Shopify.shop;
            }

            fetch(SYNER_URL + "/api/field?shopDomain=" + shop)
                .then(async response => {
                    if (!response.ok) {
                        return;
                    }
                    const data = await response.json();
                    if (data.enabled === false) {
                        console.log("Syner field is disabled");
                        return;
                    }

                    buildField(data.location, $);
                })
                .catch((e) => {
                    console.error(e);
                    console.log("could not fetch syner field");
                });
        }
    };

    if (typeof jQuery === "undefined" || parseFloat(jQuery.fn.jquery) < 1.7) {
        loadScript(
            "//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js",
            function () {
                let jQuery191 = jQuery.noConflict(true);
                myAppJavaScript(jQuery191);
            }
        );
    } else {
        myAppJavaScript(jQuery);
    }
})();
